import React, { useMemo } from "react";
import {
  MaterialReactTable,
  useMaterialReactTable,
  type MRT_ColumnDef,
} from "material-react-table";
import { Controller } from "../../../Model/controller";
import TEST_DATA from "./controllers.json";
import XBOX_LOGO from "../../../Assets/Icons/xbox.png";
import PS_LOGO from "../../../Assets/Icons/playstation.png";
import NewControllerDialog from "../../../Components/Dialog/newController";
import { Col, Container, Row } from "react-bootstrap";

// import "rsuite/dist/rsuite.min.css";
// import { Button, Table } from "rsuite";

// const { Column, HeaderCell, Cell } = Table;

const ControllersSub: React.FC = () => {
  return (
    <Container style={{ background: "tomato" }}>
      <Row>
        <Col>
          <div
            style={{
              width: "flex",
              flexFlow: "column",
              justifyContent: "center",
            }}
          >
            <h1>JOY-sticks</h1>
            <NewControllerDialog child={undefined} />
          </div>
        </Col>
        <Col>
          <div style={{ width: "flex", flexFlow: "column" }}>
            <h1>JOY-sticks</h1>
            <NewControllerDialog child={undefined} />
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ControllersSub;
